export const SET_WALLET_ADDRESS = "SET_WALLET_ADDRESS";
export const SET_CLICKED_NFM = "SET_CLICKED_NFM";
export const SET_COLLECTION_ITEMS = "SET_COLLECTION_ITEMS";
export const SET_STAKED_ITEMS = "SET_STAKED_ITEMS";